{
    "status": {
        "inPrograming": "En programación",
        "planned": "Planificado",
        "published": "Publicado",
        "canceled": "Cancelado",
        "completed": "Finalizado"
    },
    "format": {
        "standard": "Estándar",
        "withoutDates": "Sin fechas",
        "onlyInfo": "Solo info"
    },
    "soloInfoScope": {
        "all": "Todos",
        "onlyProgramming": "Solo programación"
    },
    "priority": {
        "veryHigh": "Muy alta",
        "high": "Alta",
        "normal": "Normal",
        "low": "Baja",
        "veryLow": "Muy baja"
    },
    "individualPayloadKeys": {
        "status": "Estado de la sesión",
        "sessionFinishByAction": "Cierre de sesión según acción",
        "sessionFinishAt": "Cierre de sesión según hora",
        "eventSessionIndividualZones": "Aforo y precios",
        "merchandising": "Merchandising",
        "subtitle": "Subtítulo de la web",
        "websiteAlert": "Alerta de la web"
    },
    "ticketType": {
        "online": "Online",
        "ticketOffice": "Taquilla",
        "directAccess": "Acceso directo"
    },
    "ticketWindow": {
        "halfHourBefore": "Media hora antes de la función",
        "oneHourBefore": "Una hora antes de la función",
        "twoHourBefore": "Dos horas antes de la función",
        "viewConditions": "Ver condiciones",
        "other": "Otro"
    },
    "ticketCodeType": {
        "automatic": "Automática",
        "manual": "Manual - solo códigos",
        "many": "Manual - códigos y entradas asociadas",
        "preGenerated": "Autogenerado"
    },
    "ticketCodeTypeDescription": {
        "automatic": "Funcionamiento por defecto. Los códigos QR se generan automaticamente al comprar una entrada",
        "manual": "Fichero con un listado de códigos. La cantidad de códigos debe ser igual o superior al aforo reservado para Abono",
        "many": "Fichero con un listado doble de datos: códigos y entradas asociadas. La cantidad de códigos debe ser igual o superior al aforo reservado para Abono",
        "preGenerated": "Listado de códigos generados por la plataforma según los parámetros siguientes"
    },
    "ticketFormat": {
        "pdf": "Email con PDF adjunto",
        "code": "Email con código canjeable online"
    },
    "ticketFormatDescription": {
        "pdf": "El PDF adjunto funciona como una entrada digital",
        "code": "El email contiene un código y un enlace para canjear el código por una entrada"
    }
}
